import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons'
import { Button, type ButtonProps } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreBooking } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useBookingPublicLink } from '../../hooks/useBookingPublicLink'

type ButtonBookingFlectoLinkCopyProps = ButtonProps & {
  booking?: CoreBooking
}

export function ButtonBookingFlectoLinkCopy({
  booking,
  ...props
}: ButtonBookingFlectoLinkCopyProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'bookings' })

  const { url } = useBookingPublicLink({ bookingId: booking?.internal_id })

  const clipboard = useClipboard({ timeout: 500 })

  return (
    <Button
      variant='white'
      onClick={() => clipboard.copy(url)}
      px={0}
      {...props}
    >
      <Icon icon={clipboard.copied ? faCheck : faCopy} mr='sm' />
      {t(
        clipboard.copied
          ? 'label_button_flecto_link_copied'
          : 'label_button_flecto_link_copy'
      )}
    </Button>
  )
}
